define([
	"dojo/_base/declare",
	"csi/html",
	"csi/heading/String"
], function(declare,html,StringRen) {

	return declare(StringRen, {
		bBaseRenderer: true,
		
		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render value for string showing parameters with grey background and tooltip
			var	value = this._getValue(ctx, h);
			if (!value) return false;

			var	lr = ctx.view.get("store").lrBase;
			var	a = value.split("${");
			var	n = 0;
			var	b, v;

			if (a[0]) {
				html.text(refNode, a[0]);
			}

			while (v = a[++n]) {
				b = v.split("}");

				if (isNaN(b[0])) {
					html.create("span", {
						"class": "csi-bg-changed",
						innerText: lr.getParameterResource(b[0]),
						title: lr.getParameterDescription(b[0])
					}, refNode);

					html.text(refNode, b[1]);
				} else {
					html.text(refNode, "${" + a[n]);
				}
			}

			return true;
		}
	});
});